import React from 'react'
import Pagination from '../../common/Pagination/Pagination'
import ReactTable from "react-table";
import "react-table/react-table.css";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";
import find from "lodash/find";
import { Button } from '../../common/Button/Button';
import { toast } from 'react-toastify';
import copysvg from '../../assets/arrow_copy.svg';

const ReactTableFixedColumns = withFixedColumns(ReactTable);


const ESPUmcReactTable = (props) => {

	const copyToClipboard = (content) => {
		const el = document.createElement('textarea');
		el.value = content;
		document.body.appendChild(el);
		el.select();
		document.execCommand('copy');
		document.body.removeChild(el);
	};

    const columns = [
        {
            id: 'checkbox',
            Header: (
                <input
                    type="checkbox"
                    onChange={props.handleSelectAll}
                    checked={
						props.data
							.filter(service => service.custrefSRState !== 'Delivered' && service.custrefSRState !== 'Cancelled')
							.every(service => props.selectedServices.includes(service.nResourceInstanceId))
					}
					disabled={
						props.data.every(service => service.custrefSRState === 'Delivered' || service.custrefSRState === 'Cancelled')
					}
                />
            ),
            width: 50,
            accessor: '',
            Cell: ({ original }) => (
                <input
                    type="checkbox"
                    onChange={() => props.handleCheckboxChange(original.nResourceInstanceId)}
                    checked={props.isSelected(original.nResourceInstanceId)}
					disabled={original.custrefSRState === 'Delivered' || original.custrefSRState === 'Cancelled'}
                />
            )
        },
        {
			id: "sServiceName",
			Header: "Service Name",
			headerStyle: { 'whiteSpace': 'normal', 'borderBottom': 'solid 1px #ccc' },
			accessor: "sServiceName",
			Cell: ({ original }) => (
                <div className='text-center'>
				<span className='conv-text-center' style={{whiteSpace: 'pre-wrap'}}>
				{
					(original.sServiceCode === "MKTLINKAGEEXHIBITION" || original.sServiceCode === "MKTLINKAGEBULKBUYER" ||
					original.sServiceCode === "MKTLINKAGEECOM" ||original.sServiceCode === "MKTLINKAGECORPLINKAGE" ||
					original.sServiceCode === "MKTLINKAGESHOPINSHOP" ||original.sServiceCode === "MKTLINKAGEEXPORT") && original.sServiceDisplayName ?
					original.sServiceName ?
						original.sServiceName + " " + `(${original.sServiceDisplayName})` :
						original.refServiceType ?
							original.refServiceType.sServiceName + " " + `(${original.sServiceDisplayName})` :
							""
				:
				original.sServiceName ?
					original.sServiceName :
					original.refServiceType ?
						original.refServiceType.sServiceName :
						""
				}
						</span>
                        <div>
                            <span style={{
                                color: "#76287C"
                            }} className='mt-2 conv-mr18 lpm-service-grid-key text-center'>
                                ID : {
                                    original.nResourceInstanceId?
                                    original.nResourceInstanceId 
                                    :
                                    "NA"
                                }
                            </span>
                        </div>
                        </div>
			),
		},
        {
			id: "sFirstName",
			Header: "Customer Name",
			headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc' },
			accessor: "sFirstName",
			Cell: ({ original }) => (
				<div className='text-center'>
					<div className={"conv-float-left conv-mr5"}>
						{
							original.bNeedToTalkToSP ? (<><div className={"blue-dot"}></div><br></br></>) : ("")
						}
						{
							original.sExternalHHEmail ? (<><div className={"green-dot"}></div></>) : ("")
						}
					</div>
					{
						`${original.sFirstName ?
							original.sFirstName :
							original.customer_meta ?
								original.customer_meta.first_name :
								""
						}${' '}
						${original.sLastName ?
							original.sLastName :
							original.customer_meta ?
								original.customer_meta.last_name :
								""
						}`
					}
				</div>
			),
		},
		{
			id: "sEmailAddress",
			Header: "Customer Email ID",
			headerStyle: { 'whiteSpace': 'normal', 'wordBreak': 'break-all', 'borderBottom': 'solid 1px #ccc' },
			accessor: "sEmailAddress",
			Cell: ({ original }) => (
				<div className='text-center'>
							<span style={{
                                'whiteSpace': 'normal', 'wordBreak': 'break-all',
                            }}>
								{
									original.sEmailAddress
								}
							</span>
				</div>
			),
		},
		{
			id: "sContactNumber",
			Header: "Phone No.",
			width: 140,
			headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc' },
			accessor: "sContactNumber",
			Cell: ({ original }) => (
				<div className='text-center'>
					<span>
						{
							original.sContactNumber
						}
					</span>
					<img
						alt="copy"
						src={copysvg}
						height={"20px"}
						width={"16px"}
						className="con-cursor-pointer conv-mr13 conv-ml10"
						onClick={(e) => {
							e.preventDefault();
							copyToClipboard(original.sContactNumber);
							toast(`${original.sFirstName ?
								original.sFirstName :
								original.customer_meta ?
									original.customer_meta.first_name :
									""
								}${' '}
							${original.sLastName ?
									original.sLastName :
									original.customer_meta ?
										original.customer_meta.last_name :
										""
								}'s Contact Copied!`, {
								autoClose: 5000,
								type: toast.TYPE.SUCCESS,
							});
						}}
					/>
				</div>
			)
		},
		{
			id: 'sCatalogue',
			Header: 'Catlogue - Yes / No',
			width: 100,
			style: { 'whiteSpace': 'unset' },
			headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc' },
			accessor: "sCatalogue",
			Cell: ({ value, row }) => <div className='text-center'>
				{value === 'Yes' ? (
					<a href='#' style={{ textDecoration: 'underline', color: '#78417C' }}
					onClick={(original) => props.handleCatalogueClick(row)}
					>Yes</a>
				) : (
					value
				)}
			</div>
		},
        {
			id: "custrefSRState",
			Header: "Service Status",
			headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc' },
			accessor: "custrefSRState",
			style: { 'whiteSpace': 'unset' },
			Cell: ({ original }) => (
				<div className='text-center'>
					{
						original.custrefSRState == "Cancelled" || original.custrefSRState == "Delivered" ?
							(
								<span>{original.custrefSRState}</span>
							) :
							(
								<span>
									{
										original.sPaymentReceiver == "Partner" ?
											(
												original.custrefSRState == "Prepared" ||
													original.custrefSRState == "Ready For Progression" ?
													"Willing to Pay" :
													original.custrefSRState == "Partial/ Full Payment Pending" ?
														"Willing to Pay" :
														original.custrefSRState == "Payment Confirmed By Partner" ?
															"Payment Received" :
															original.custrefSRState
											) :
											original.custrefSRState == "Prepared" || original.custrefSRState == "Partial/ Full Payment Pending" ?
												"Willing to Pay" :
												original.custrefSRState == "Payment Received" ||
													original.custrefSRState == "Ready For Progression" ?
													"Payment Received" :
													original.custrefSRState
									}
								</span>
							)
					}
				</div>
			)
		},
        {
            id: 'sBusinessName',
            Header: 'Business Name',
            style: { 'whiteSpace': 'unset' },
            headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
            accessor: "sBusinessName",
            Cell: ({ value }) => <div className='text-center'>{value}</div>
        },
        {
            id: 'enterRevenue',
            Header: 'Enter Revenue',
            Cell: ({original}) => (
                <div className='text-center'>
                    {
                        original.custrefSRState === "Delivered" ?
						original.umcrevenue === "0" ?
                            <button onClick={() => props.onEnterRevenueClick(original)}
                                style={{
                                    padding: '5px 10px',
                                    border: '1px solid gray',
                                    background: '#76287C',
                                    color: '#fff',
                                    fontWeight: 600
                                }}>Enter Revenue</button>
								:
								original.umcrevenue
                            :
                            "NA"
                    }
                </div>
                // <Button className="con-btn-filled" 
                // // onClick={() => handleEnterRevenueClick()}
                // >Enter Revenue</Button>
            )
        }
    ]

  return (
    <div className="col-12 conv-mt25 conv-pl40 conv-pr40 spled-container fix-filter">

        <div className="spled-container">
            <div className="service-partner spled-container">
            <ReactTableFixedColumns
						minRows={0}
						data={props.data || []}
						columns={columns}
						manual
						defaultPage={props.page}
						pages={props.pages}
						page={props.page}
						pageSize={props.pageSize}
						sortable={false}
						defaultPageSize={10}
						showPagination={true}
						pageSizeOptions={[10,20,30,50,75,100]}
						onFetchData={(state, instance) => {
							props.onFetchServiceRequests(instance, false);
						}}
						onPageSizeChange={props.onPageSizeOptionChange}
						// PaginationComponent={Pagination}
						PaginationComponent={(paginationProps) => (
							<Pagination
								{...paginationProps}
								displayRecordCount={props?.displayRecordCount}
						/>
						)}
						style={{overflowY: "initial",height: "390px"}}			
						className="-striped hide-scrollbar"
					/>
            </div>
        </div>
      
    </div>
  )
}

export default ESPUmcReactTable
